export const RATING_DATE_FORMAT = 'DD MMM YYYY';
